module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Deploy Component","headline":"This wizard will guide you in adding a new component to your Unryo system.","content":"Once added, the component will be automatically connected, and will communicate securely and seamlessly with its peers, whether they are located on-premises or off-premises."}}')
  delete Component.options._Ctor
}
